import moment from 'moment';

/**
 * Filtr wyświetlania daty
 *
 * @export
 * @param {(Date | string)} dateToFormat
 * @returns {string}
 */
export function date(dateToFormat: Date | string): string {
  return moment(dateToFormat).format('DD.MM.YYYY');
}

/**
 * Filtr wyświetlania daty z czasem
 *
 * @export
 * @param {(Date | string)} dateToFormat
 * @returns {string}
 */
export function dateTime(dateToFormat: Date | string): string {
  return moment(dateToFormat).format('DD.MM.YYYY HH:mm:ss');
}
